import { getFullUserName, getUniqueFullUserNamesMap } from "../Account/helpers"
import { ProviderDisclosure, ProviderPhoto } from "./schema"

export const stitchDisclosuresFullName = async (
  disclosures: ProviderDisclosure[],
  haAdminText: string | undefined,
): Promise<ProviderDisclosure[]> => {
  const userIdsToHydrate: (string | undefined)[] = []
  disclosures.forEach((disclosure) => {
    if (disclosure?.createdBy) {
      userIdsToHydrate.push(disclosure.createdBy)
    }
  })
  const uniqueUserIds = Array.from(
    new Set(userIdsToHydrate.filter((id): id is string => !!id)),
  )
  const userIdToFullNameMap = await getUniqueFullUserNamesMap(
    uniqueUserIds,
    haAdminText,
  )
  const updatedDisclosures = disclosures.map((disclosure) => {
    if (disclosure?.createdBy) {
      return {
        ...disclosure,
        createdByFullName: userIdToFullNameMap[disclosure.createdBy] || "",
      }
    }

    return disclosure
  })

  return updatedDisclosures
}

export const stitchProviderPhotoFullName = async (
  providerPhoto?: ProviderPhoto,
  haAdminText?: string,
): Promise<ProviderPhoto | undefined> => {
  if (providerPhoto?.createdBy) {
    const createdByFullName = await getFullUserName(
      providerPhoto.createdBy,
      haAdminText,
    )

    return {
      ...providerPhoto,
      createdByFullName: createdByFullName,
    }
  }

  return providerPhoto
}
